import { useState } from 'react'

import { getStorageItem, setStorageItem } from 'lib/utils/storageUtils'

const DEBUG_MODE_KEY = 'debug-mode-enabled'

/**
 * The switch behind every developer-only thing in the quote editor - the logs,
 * and the inspectors as they arrive.
 *
 * It's off by default everywhere, including locally. Turning it on in dev only
 * would mean local runs and CI behave differently, and integration tests would
 * start passing on one and failing on the other.
 */
export const isDebugModeEnabled = () => getStorageItem(DEBUG_MODE_KEY, false)

/**
 * For the dev tools bar's own switch. Nothing else needs telling when this
 * changes: everything behind it reads the stored value at the moment it logs,
 * so the next log picks the new setting up on its own.
 */
export const useDebugMode = (): [boolean, (value: boolean) => void] => {
  const [isEnabled, setIsEnabled] = useState(isDebugModeEnabled)

  return [
    isEnabled,
    (value: boolean) => {
      setStorageItem(DEBUG_MODE_KEY, value)
      setIsEnabled(value)
    }
  ]
}
